import * as types from '../../actions/actionsTypes/individuoActionType'
import {printOnlyInDevelopment} from "../../fanctionUtility";

export const initialStateIndividui = {
    individui: [],
    error: [],
    individuiSelezionati: []
};

export const individuiReducer = (state = initialStateIndividui, action) => {
    switch (action.type) {
        case types.SET_INDIVIDUI_SELEZIONATI :
            printOnlyInDevelopment('Individui in attesa di timbratura ::', action.arrObjIdIndividui);
            return{
                ...state,
                individuiSelezionati: action.arrObjIdIndividui
            };

        case types.GET_INDIVIDUI_BY_OBJECTID_SUCCESS:
            /*const new_individuo = Object.assign({}, action.individuo, {idAnagrafica: action.idAnagrafica});
            const __individui = !state.individui.includes(new_individuo) ?
                (state.individui.concat(new_individuo))
                    .sort((a, b) =>
                        (a.cognome > b.cognome) ? 1 : ((b.cognome > a.cognome) ? -1 : 0)) :
                state.individui;*/
            return{
                ...state,
                individui: action.individui.map(i => ({...i, idAnagrafica: i.id}))
            };

        case types.GET_INDIVIDUI_BY_OBJECTID_FAIL:
            return{
                ...state,
                error: [action.error, ...state.error]
            };

        case types.INIT_INDIVIDUI_SELEZIONATI:
            printOnlyInDevelopment('Initialization array selected Individui');
            return {
                ...state,
                error: [],
                individuiSelezionati: []
            };

        case types.INIT_INDIVIDUI:
            printOnlyInDevelopment('Initialization array Individui');
            return {
                individui: [],
                error: [],
                individuiSelezionati: []
            };

        default:
            return state;
    }
};

